import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import AcademyBilledCoursesTable from 'modules/academies/components/AcademyBilledCoursesTable';

import { useBilledCourses } from 'modules/academies/hooks';

const AcademyBilledCoursesPage = () => {
  const history = useHistory();
  const { courses, loading } = useBilledCourses();

  const onSelectCourse = useCallback(
    (course) => {
      history.push(`/billing-legacy/courses/${course._id}`);
    },
    [history]
  );

  return <AcademyBilledCoursesTable courses={courses} loading={loading} onSelectCourse={onSelectCourse} />;
};

export default AcademyBilledCoursesPage;
